import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

export const initialize = () => {
  // Initialize Datadog RUM
  datadogRum.init({
    applicationId: "4bcdf6fe-4d2a-4ca5-b274-7b6a9b8dba8e",
    clientToken: "pubff56a53222bfbe3533aeffaef12cf643",
    site: 'datadoghq.eu',
    service: 'cropwise-financials-web',
    env: "prod",
    version: '1.0.0',
    sampleRate: 75,
    trackInteractions: true,
    trackResources: true,
    defaultPrivacyLevel: 'allow'
  });

  // Initialize Datadog Logs
  datadogLogs.init({
    clientToken: "pubff56a53222bfbe3533aeffaef12cf643",
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sampleRate: 75
  });

  // Enable session replay
  datadogRum.startSessionReplayRecording({ force: true });
};

export const addUserAttributes = (userId, email) => {
  datadogRum.setUser({ id: userId, email });
};

export const resetUserAttributes = () => {
  datadogRum.setUser({});
};
